
import axios from 'axios';
import UserDuplicateListActionTypes from './user-duplicate-list-action-types';
import { loadUserOverviewPage, selectUserOverviewPageTab } from '../actions/user-overview-page-actions';

export const mergeUsers = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: UserDuplicateListActionTypes.MERGE_USER_DUPLICATES_START });
  const state = getState().userDuplicateList;
  const mergeWithUser = state.mergeWithUser;
  dispatch({ type: UserDuplicateListActionTypes.TOGGLE_USER_MERGE_CONFIRM_DIALOG });
  try {
    state.userDuplicatesCancelToken?.cancel();
    state.userDuplicatesCancelToken = axios.CancelToken.source();
    await api.put(`api/users/${payload.userId}/merge`, mergeWithUser, state.userDuplicatesCancelToken.token);
    dispatch({ type: UserDuplicateListActionTypes.MERGE_USER_DUPLICATES_END });
    if (payload.userDuplicates?.length === 1) {
      dispatch(selectUserOverviewPageTab({ selected: 0 }));
    }
    dispatch(loadUserOverviewPage({ userId: payload.userId }));
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: UserDuplicateListActionTypes.MERGE_USER_DUPLICATES_END });
      throw error;
    }
  }
};

export const toggleUserMergeConfirmDialog = (payload) => async(dispatch) => {
  dispatch({
    type: UserDuplicateListActionTypes.TOGGLE_USER_MERGE_CONFIRM_DIALOG,
    payload: payload
  });
};